import React, {Component} from 'react';
import Radium from 'radium';
import color from 'color';

const MessageListLink = (props) => {
	const { message, client, parentStyles, lastElement } = props;

	return (
		<div className="message m-type_link">
			<a className="message__body" 
				target="_blank"
				href={message.get("linkUrl")}
				style={[
					parentStyles.message.body,
					message === lastElement && parentStyles.message.body.appear,
					styles.link
				]}
			>
				{(message.get("previewTitle") || message.get("previewDescription")) && 
					<div className="message__body__preview" style={[styles.link.preview]}>
						<div className="message__body__preview__title" style={[styles.link.preview.title]} >{message.get("previewTitle")}</div>
						<div className="message__body__preview__description" style={[styles.link.preview.description]} >{message.get("previewDescription")}</div>
						<div 
							className="message__body__preview__icon" 
							style={[
								{backgroundImage: `url(${message.get("icon")})`},
								styles.link.preview.icon
							]}
						></div>
					</div>
				}
				<div className="message__body__title" style={[styles.link.title]}>
					{message.get("body") ? message.get("body") : "Link"}
					<div className="message__body__title__icon" style={[styles.link.title.icon]}></div>
				</div>
			</a>
		</div>
	)
}

const styles = {
	link: {
		padding: '0',
		borderStyle: 'solid',
		borderWidth: '1px',
		borderColor: '#e4e5ea',
		position: 'relative',	
		overflow: 'hidden',
		color: 'black',
		textDecoration: 'none',
		width: '100%',

		preview: {
			backgroundColor: 'white',
			padding: '6px 12px',
			minHeight: '27px',

			title: {
				fontWeight: '500',
				padding: '4px 30px 4px 0px'
			},

			description: {
				fontSize: '0.9em'
			},

            icon: {
                width: '20px',
                height: '20px',
                position: 'absolute',
                top: '9px',		           
                right: '9px',		
                borderRadius: '2px',
                backgroundPosition: 'center',
                backgroundSize: 'cover'
            }
		},

		title: {
			padding: '6px 26px 6px 12px',
			textDecoration: 'underline',
			position: 'relative',

            icon: {
                width: '20px',
                height: '20px',
                position: 'absolute',
                bottom: '6px',		           
                right: '6px',		 
                backgroundImage: 'url("https://d124s1zbdqkqqe.cloudfront.net/ArrowNE.svg")',
                backgroundPosition: 'center',
                backgroundSize: 'contain'
            }
		}
	}
}

export default Radium(MessageListLink);


// WEBPACK FOOTER //
// ./src/components/MessageList/MessageListLink.js